import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Gauge } from 'lucide-react';
import { vendorSlaService } from '../../services/vendorSla.service';

const WATCH_BANDS = new Set(['WATCH', 'POOR']);

const chip = (r) => {
    if (r.is_suspended) return 'bg-red-100 text-red-700';
    if (r.band === 'POOR') return 'bg-red-100 text-red-700';
    return 'bg-amber-100 text-amber-800';
};

const SlaWatchlist = () => {
    const navigate = useNavigate();
    const [rows, setRows] = useState(null);

    useEffect(() => {
        vendorSlaService
            .leaderboard({ limit: 500 })
            .then((res) => {
                const items = Array.isArray(res?.items) ? res.items : [];
                setRows(
                    items
                        .filter((r) => r.is_suspended || WATCH_BANDS.has(r.band))
                        .sort((a, b) => (a.sla_score ?? 999) - (b.sla_score ?? 999))
                        .slice(0, 8),
                );
            })
            .catch(() => setRows([]));
    }, []);

    return (
        <div className="bg-white rounded-xl bxshadow mrgall border bxshadowh">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                    <Gauge className="w-4 h-4" /> SLA Watchlist
                </h2>
                <button
                    type="button"
                    className="text-xs text-blue-600 hover:underline"
                    onClick={() => navigate('/vendor-performance')}
                >
                    View all
                </button>
            </div>
            {rows == null && <p className="text-sm text-gray-400">Loading…</p>}
            {rows != null && rows.length === 0 && (
                <p className="text-sm text-gray-400">No vendors on watch.</p>
            )}
            <div className="space-y-2">
                {(rows || []).map((r) => (
                    <button
                        type="button"
                        key={r.vendor_id}
                        onClick={() => navigate('/vendor-performance')}
                        className="flex items-center justify-between w-full p-2 rounded-md hover:bg-gray-50 text-left"
                    >
                        <div>
                            <p className="text-sm font-medium">{r.vendor_name}</p>
                            <p className="text-[11px] text-gray-400">
                                {r.jobs_in_window} jobs · accept{' '}
                                {r.acceptance_rate == null ? '—' : `${Math.round(r.acceptance_rate * 100)}%`} · rating{' '}
                                {r.avg_rating == null ? '—' : r.avg_rating.toFixed(1)}
                            </p>
                        </div>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${chip(r)}`}>
                            {r.is_suspended ? 'SUSPENDED' : `${r.band} · ${r.sla_score == null ? '—' : r.sla_score.toFixed(0)}`}
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SlaWatchlist;
